import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface AutoCompleteInterface {
  label: string
}

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss']
})
export class AutoCompleteComponent implements OnInit, OnChanges {
  active: boolean = false;
  originalOptions: AutoCompleteInterface[] = []

  @Input() height = 20;
  @Input() placeholder: string = 'Auto complete'
  @Input() control: FormControl = new FormControl();
  @Input() options: AutoCompleteInterface[] = [];

  ngOnInit(): void {
    this.originalOptions =  this.options;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.originalOptions =  this.options;
  }

  selectOption(option: AutoCompleteInterface): void {
    this.control.setValue(option.label);
    this.active = false;
    this.options = this.originalOptions;
  }

  toogleDropdown(): void {
    this.active = !this.active;
  }

  filterOptions(event: Event): void {
    const value = (event.target as HTMLInputElement).value 
    
    if (value.length > 0) {
      const filterOptions = this.originalOptions.filter(o => o.label.toLowerCase().includes(value.toLowerCase()))
      this.options = filterOptions;

      if (this.options.length > 0) {
        this.active = true;
      } else {
        this.active = false
      }
    } else {
      this.active = false
      this.options = this.originalOptions
    }
   }
}
